import { useMutation } from 'convex/react';
import { api } from '../../../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: benefit-plan-tabs subdirectory requires four levels up to reach convex/_generated/
import { EditableJsonTable } from './EditableJsonTable';
import type { IBenefitPlan, IBenefitSection, IBenefitItem, IClaimsRule } from '@/@types/claims';
import type { IEditableJsonTableColumn } from '@/@types/insurance';

interface IClaimsAndRulesTabProps {
  // LOCAL_TYPE_JUSTIFIED: component-specific props combining plan with enriched sections
  plan: IBenefitPlan & {
    sections: Array<IBenefitSection & { items: IBenefitItem[] }>;
  };
}

const RULE_TYPE_COLORS: Record<string, 'green' | 'blue' | 'orange' | 'red'> = {
  Deductible: 'green',
  'Co-Insurance': 'blue',
  'Out-of-Network': 'orange',
  'Claims Deadline': 'red',
  'Claims submission deadline': 'red',
  Reimbursement: 'green',
  'Reimbursement timeline': 'green',
  'Direct Billing': 'blue',
  'Direct billing': 'blue',
  'Coordination of Benefits': 'orange',
  'Coordination of benefits': 'orange',
  'Fraud and Misrepresentation': 'red',
  'Fraud and misrepresentation': 'red',
  'Claims criteria': 'green',
  'Claims honoré': 'green',
  'Allowable Charge': 'blue',
  Currency: 'blue',
};

const COLUMNS: IEditableJsonTableColumn<IClaimsRule>[] = [
  { key: 'id', header: 'ID', width: '50px', readOnly: true },
  { key: 'ruleType', header: 'Rule Type', width: '200px', badgeColorMap: RULE_TYPE_COLORS },
  { key: 'ruleDetail', header: 'Rule Detail' },
];

export function ClaimsAndRulesTab({ plan }: IClaimsAndRulesTabProps) {
  const updateTabData = useMutation(api.insurance.benefitPlans.updateTabData);

  const rows: IClaimsRule[] = (plan.claimsRules ?? []).map((r, i) => ({
    ...r,
    id: r.id || `R${String(i + 1).padStart(3, '0')}`,
  }));

  async function handleSave(updated: IClaimsRule[]) {
    await updateTabData({ planId: plan._id, field: 'claimsRules', data: updated });
  }

  return (
    <div className="py-6 px-8">
      <EditableJsonTable
        rows={rows}
        columns={COLUMNS}
        idPrefix="R"
        onSave={handleSave}
        emptyMessage="No claims rules defined."
      />
    </div>
  );
}
